/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Other_Students16Inputs */

const en__field_enum_mzs_other_students16 = /** @type {(inputs: _Field_Enum_Mzs_Other_Students16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other students`)
};

const de__field_enum_mzs_other_students16 = /** @type {(inputs: _Field_Enum_Mzs_Other_Students16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`andere Studierende`)
};

/**
* | output |
* | --- |
* | "other students" |
*
* @param {_Field_Enum_Mzs_Other_Students16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_other_students16 = /** @type {((inputs?: _Field_Enum_Mzs_Other_Students16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Other_Students16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_other_students16(inputs)
	return de__field_enum_mzs_other_students16(inputs)
});
export { _field_enum_mzs_other_students16 as "_field_enum_MZS_OTHER_STUDENTS" }